<template>      
  <v-content>                      
    <page-header v-if="$route.meta.breadcrumb"></page-header>
    <router-view style="padding-bottom: 35px;" />                                            
    <v-footer class="pa-2">
        <span class="caption">
            {{footerCopyright}}
        </span> 
        <div class="spacer"></div> 
        <span class="caption mr-1"> {{footerTagline}} </span> 
        <i aria-hidden="true" class="v-icon cyan--text material-icons" style="font-size: 20px;">{{footerIcon}}</i>
    </v-footer>
  </v-content>      
</template>

<script>
import PageHeader from './PageHeader';


export default {
  name: 'app-content',
  components: { 
    PageHeader,           
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 60
    },
    footerCopyright: 'DTM v.3.0 © 2019',
    footerTagline  : '',
    footerIcon     : 'android',    
  }),

  methods: {
   
  }
};
</script>
